// extracted by mini-css-extract-plugin
export default {"scroll-progress":"dhhs-scroll-progress","scrollProgress":"dhhs-scroll-progress"};